import { render, staticRenderFns } from "./champ_text.vue?vue&type=template&id=4afacd9a"
import script from "./champ_text.js?vue&type=script&lang=js&external"
export * from "./champ_text.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports